import { createContext } from "react";
import { ContentfulClientApi } from "contentful";

export type ContentfulClientInterface = ContentfulClientApi<undefined>;

export const ContentfulContext =
  createContext<ContentfulClientInterface | null>(null);
